export const VELOCITY_LIMIT_LIST_ATTRIBUTES_CONSTANT = {
  search: {
    type: 'text',
    key: 'search',
    label: 'Search',
    placeholder: 'source/dest currency',
  },
} as const;
